// Return a list of tokens, which are either mentions or words.
// mentions are in the format @[display name](/resource).
import { UserFragment } from '@spotify/confidence-graphql';
import { identityNameFromUser } from '@spotify/plugin-confidence-iam-react';

// words are any other string.
export const tokenizeTextWithMentions = (input: string) => {
  const tokens = [];
  const mentionRegex = /@\[(.*?)\]\((.*?)\)/g;

  while (true) {
    const lastIndex = mentionRegex.lastIndex;
    const mention = mentionRegex.exec(input);
    if (mention) {
      // push any text before the mention
      const before = input.slice(lastIndex, mention.index);
      if (before) {
        tokens.push(before);
      }

      // extract the matching groups from the mention
      const [_, displayName, name] = mention;
      tokens.push({ displayName, name });
    } else {
      // push any remaining text
      tokens.push(input.slice(lastIndex));
      break;
    }
  }

  return tokens;
};

// Extract mentions from a string.
export const extractEmailMentions = (input: string) => {
  return [...input.matchAll(/@([^\s]+)/g)].map(match => match[0].slice(1));
};

// Take a string with `@<email>` mentions and replace them with markdown
// style mentions `@[<email>](/user/resource)` mentions.
export const replaceEmailsWithMentions = (
  text: string,
  users: UserFragment[],
) => {
  const emailRegex = /@([^\s]+)/g;
  return text.replace(emailRegex, (_, email) => {
    const user = users.find(u => u.email === email);
    const identityName = user ? identityNameFromUser(user.name) : undefined;
    return user ? `@[${user.email}](${identityName})` : `@${email}`;
  });
};
